function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M32 48.78a1.5 1.5 0 01-1.06-2.56L61.5 15.66a1.5 1.5 0 012.12 2.12L33.06 48.34a1.5 1.5 0 01-1.06.44z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 48.78a1.5 1.5 0 01-1.06-.44L.38 17.78a1.5 1.5 0 012.12-2.12l30.56 30.56A1.5 1.5 0 0132 48.78z"
});

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2);
}

export default SvgDownArrow;